import TripsByDirection from '@/components/manage/tickets/TripsByDirection';
import { manageFlowBookingSelector } from '@/features/manage/manageSelectors';
import { useBookingTrips } from '@/hooks/useBookingTrips';
import { useSelector } from '@/store/utils';
import type { CheckoutOrBookingPassengerMap } from '@/types/passenger';
import { tripHasActiveAdmissions } from '@/utils/booking';
import { Divider } from '@fleet/webshop-ui';
import type { FC } from 'react';

interface BookedTripsDetailsProps {
  passengersMap: CheckoutOrBookingPassengerMap;
}

const Tickets: FC<BookedTripsDetailsProps> = ({ passengersMap }) => {
  const booking = useSelector(manageFlowBookingSelector);
  const { outboundTrips, inboundTrips } = useBookingTrips(booking);

  // Drop trips whose passengers were all moved off via change-booking — their
  // admissions are all inactive, so they'd otherwise render as empty trips
  // (no passenger count, no leg cards). Filtering here keeps the per-direction
  // header counts and the return-section gating consistent with what renders.
  const activeOutboundTrips = outboundTrips.filter(tripHasActiveAdmissions);
  const activeInboundTrips = inboundTrips.filter(tripHasActiveAdmissions);

  return (
    <div className="flex flex-1 flex-col">
      <TripsByDirection
        trips={activeOutboundTrips}
        passengersMap={passengersMap}
        header="outboundTrips"
      />
      {!!activeInboundTrips.length && (
        <>
          <Divider className="my-4" grow={false} />
          <TripsByDirection
            trips={activeInboundTrips}
            passengersMap={passengersMap}
            header="returnTrip"
          />
        </>
      )}
    </div>
  );
};

export default Tickets;
